import {
  Component,
  Injector,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Module } from 'projects/common/model/ModuleModel';
import { LandingModel } from 'projects/common/model/landingModel';
import { AbstractComponent } from '../abstract.component';
import { InputModel } from '../form/inputs.model';

interface LandingHistoryItem {
  date: string;
  date_formatted: string;
  item_update_by: string;
}

interface LandingHistoryData {
  history_items: LandingHistoryItem[];
}

@Component({
  selector: 'landing-history',
  template: `
    <div class="eva-card eva-3-card -eva-3-shadow-line -eva-3-p-md">
      <div class="eva-card-content">
        <h5
          class="-eva-3-mr-md eva-3-{{ screenType === 'MOBILE' ? 'h6' : 'h5' }}"
        >
          {{ 'history.see.historical' | translate }}
        </h5>

        <div
          *ngIf="module.data.history_items.length > 0"
          class="eva-3-select -lg"
        >
          <div class="select-container">
            <select
              id="landing-history-select"
              class="select-tag"
              aria-label="'Landing history options'"
              (change)="onDateChange($event)"
            >
              <option disabled selected>{{ 'history.select.date' | translate }}</option>
              <option
                *ngFor="let item of module.data?.history_items"
                [value]="item.date"
                [selected]="item.date === selectedDate"
              >
                {{ item.date_formatted }} - {{item.item_update_by}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./landing-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingHistoryComponent extends AbstractComponent {
  @Input() override module: Module<LandingHistoryData>;
  landingModel: LandingModel;
  selectedDate: string;
  model: InputModel;

  constructor(injector: Injector) {
    super(injector);
    this.landingModel = this.landingModelService.getLandingModel();
  }

  getModuleId(): string {
    return 'LandingHistoryModule';
  }

  onDateChange(e: Event) {
    this.selectedDate = (e.target as HTMLSelectElement).value;
    const currentUrl = new URL(window.location.href);
    const oid = this.landingModel.oid;
    currentUrl.searchParams.set('historyDate', this.selectedDate);
    currentUrl.searchParams.set('oid', oid);
    window.location.href = currentUrl.toString();
  }
}
